import Alert from '@mui/material/Alert'

import * as React from 'react'
import { FC } from 'react'
import { ReOpenPopupVariant } from './typings'
import { Theme, useTheme } from '@mui/material/styles'

interface Props {
  variant: ReOpenPopupVariant
}

const getStyles = (theme: Theme) => ({
  alert: {
    '&:not(:first-child)': {
      marginTop: theme.spacing(1.5),
    },
  },
})

export const ReOpenAlerts: FC<Props> = (props) => {
  const { variant } = props
  const styles = getStyles(useTheme())
  return (
    <>
      {variant === 'rejected' && (
        <Alert sx={styles.alert} severity="success">
          Re-Opening the Opportunity will revise the entry in the queue
        </Alert>
      )}
      {variant === 'submitted' && (
        <Alert sx={styles.alert} severity="warning">
          Re-Opening the Opportunity will revise the entry in the queue
        </Alert>
      )}
      {variant === 'rejected' && (
        <Alert sx={styles.alert} severity="info">
          We will save any notes from the office as a note on the Opportunity
          Detail page for reference
        </Alert>
      )}
      {(variant === 'submitted' || variant === 'rejected') && (
        <Alert sx={styles.alert} severity="info">
          We will prefill your previous submission info upon closing so you
          don&apos;t have to enter it again
        </Alert>
      )}
    </>
  )
}
ReOpenAlerts.displayName = 'ReOpenAlerts'
